(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  const stickyATC = document.querySelector(".sticky-atc");
  const mainATC = document.querySelector(".product-form__submit");

  if (!stickyATC || !mainATC) return;

  // Observe when main ATC enters/leaves viewport
  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];

      if (entry.isIntersecting) {
        // Main ATC is visible → hide sticky
        stickyATC.classList.remove("is-visible");
      } else {
        // Main ATC is OUT of viewport → show sticky
        stickyATC.classList.add("is-visible");
      }
    },
    {
      root: null,
      threshold: 0, // trigger as soon as it appears or disappears
    }
  );

  observer.observe(mainATC);
});

  (function () {
  // Helper: safe text normalize for matching (trim, collapse whitespace)
  function normalizeText(s) {
    return (s || '').toString().trim().replace(/\s+/g, ' ');
  }

  // Helper: transform label into a 'handle' like data-handle value (pack-of-6)
  function toHandle(s) {
    return normalizeText(s).toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-');
  }

  const select = document.getElementById('sticky-select');
  if (!select) return;

  // Query radios inside your variant picker block (scoped selector - adjust if needed)
  const radiosSelector = 'fieldset.product-form__input input[type="radio"]';
  function getRadios() {
    return Array.from(document.querySelectorAll(radiosSelector));
  }

  // On select change -> try to find a radio to match and trigger click/change
  select.addEventListener('change', function () {
    const selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;

    const optValue = normalizeText(selectedOption.value);      // in your markup it's the variant id (5122...)
    const optText = normalizeText(selectedOption.text || selectedOption.label); // e.g. "Pack of 6"
    const optHandle = toHandle(optText);                       // e.g. "pack-of-6"

    const radios = getRadios();

    // Matching strategies (in order):
    // 1) radio.value === optText (exact visible label match)
    // 2) radio.dataset.handle === optHandle (match data-handle like 'pack-of-6')
    // 3) radio.id contains optText or optHandle
    // 4) fallback: try to match by a data-variant-id attribute if your theme adds it (radio.dataset.variantId)
    let match = radios.find(r => normalizeText(r.value) === optText);
    if (!match) {
      match = radios.find(r => (r.dataset && normalizeText(r.dataset.handle) === optHandle));
    }
    if (!match) {
      match = radios.find(r => {
        const id = (r.id || '').toLowerCase();
        return id.includes(optHandle) || id.includes(optText.toLowerCase());
      });
    }
    if (!match) {
      match = radios.find(r => {
        // some themes render variant ids into data attributes - try common names
        const v = r.dataset.variantId || r.dataset.variant || r.getAttribute('data-variant-id') || '';
        return v === optValue || v === String(optValue);
      });
    }

    if (!match) {
      // nothing found — you can log for debugging
      console.warn('No matching radio found for select option:', { optValue, optText, optHandle });
      return;
    }

    // If there's a label associated with the input, click the label (better for native UI)
    const label = document.querySelector(`label[for="${CSS.escape(match.id)}"]`);
    if (label) {
      label.click();
    } else {
      // otherwise click the radio itself and dispatch change event
      match.click();
      // some frameworks rely on change event - dispatch it explicitly
      match.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  const stickyBtn = document.getElementById("sticky-atc-add");
  if (!stickyBtn) return;

  stickyBtn.addEventListener("click", function () {
    const mainATC = document.querySelector(".product-form__submit");
    if (!mainATC) return;

    // Save original text
    const originalText = stickyBtn.textContent;

    // Add loading state
    stickyBtn.textContent = "Adding...";
    stickyBtn.classList.add("sticky-atc-loading");
    stickyBtn.disabled = true;

    // Trigger the main ATC
    mainATC.click();

    // Restore button after short delay
    setTimeout(() => {
      stickyBtn.textContent = originalText;
      stickyBtn.classList.remove("sticky-atc-loading");
      stickyBtn.disabled = false;
    }, 1200);
  });
});
  } catch(e) { console.error(e); }
})();

})();
